module.exports = __webpack_public_path__ + "img/banner.ecc7fae9.jpg";